export const MOBILE_BANNER_TITLE = 'Одно_приложение_на_всю_недвижимость_109';
